import { useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Syncs active tab state with the `?tab=` URL search parameter.
 * Falls back to `defaultTab` when no param is present.
 */
export default function useTabFromUrl(defaultTab) {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');
  const [tab, setTabState] = useState(urlTab || defaultTab);

  const setTab = useCallback((next) => {
    setTabState(next);
    setSearchParams((prev) => {
      const p = new URLSearchParams(prev);
      if (next === defaultTab) {
        p.delete('tab');
      } else {
        p.set('tab', next);
      }
      return p;
    }, { replace: true });
  }, [defaultTab, setSearchParams]);

  return [tab, setTab];
}
